<style>

</style>
<template>
  <div></div>
</template>
<script>
// import myFile from'./pathToMyFile';

export default {
  data () {
    return {

    };
  },
  props: [
    'oi'
  ],
  mounted () {

  },
  computed: {

  },
  methods: {

  }
};
</script>



// WEBPACK FOOTER //
// src/components/modal.vue